import { jsx as _jsx } from "react/jsx-runtime";
import { useFormContext } from 'react-hook-form';
import { Size } from '@jetbrains/ring-ui/components/input/input';
import RegisteredInput from '@app/common/hook-form/registered-input';
function KeyField({ settingIndex }) {
    const { control } = useFormContext();
    return (_jsx(RegisteredInput, { label: "Key", size: Size.L, name: `content.${settingIndex}.key`, control: control }));
}
export default KeyField;
